/**
 * MobileSectionHeader — the LOCKED flush section micro-label used across the
 * mobile Home + Team Dashboard + Box Score screens (Team Home Dashboard v2.dc.html
 * / Mobile Home.dc.html). NOT a hero title: a flush flex row with a 3px accent
 * bar + a 10px/800/1px-tracked uppercase label in the SECTION accent color, and
 * an optional right-side hint (scroll / More-Less chevron / See-all) pushed right.
 * No box, no card, no border.
 *
 * `accent` is the section's color TOKEN (defaults to primary, themeable team gold);
 * Mobile Home varies it per section (League Activity success, News info, etc.).
 * Zero hardcoded colors — every value from the shared color service.
 */
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

const MobileSectionHeader = ({ title, accent, action, chevron, hint, right }) => {
  const C = dynastyTheme.tokens.colors;
  const accentColor = accent || C.primary;

  // Canonical section-label rhythm: 12px label (was 10) + symmetric 9px top/bottom
  // padding (was 6, and the old 15/5 collapsible special-case) so every consumer's
  // label renders 9px above and 9px below.
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 0' }}>
      <span aria-hidden="true" style={{ width: 3, height: 14, borderRadius: 2, background: accentColor, flexShrink: 0 }} />
      <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', color: accentColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>
        {title}
      </span>
      {/* Right slot — plain hint ("▸ scroll"), an arbitrary `right` node (e.g. the
          Box Score date-nav), and/or action / collapse chevron. */}
      {(hint || right || action || chevron) && (
        <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          {hint && <span style={{ fontSize: 8.5, color: C.neutral[500] }}>{hint}</span>}
          {right}
          {action && (
            <button onClick={action.onClick} style={{ fontSize: 8.5, fontWeight: 700, color: C.neutral[500], background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              {action.label}
            </button>
          )}
          {chevron && (
            <button
              onClick={chevron.onClick}
              aria-label={chevron.expanded ? 'Show less' : 'Show more'}
              style={{ fontSize: 8.5, fontWeight: 700, color: C.neutral[500], background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 2 }}
            >
              {chevron.expanded ? 'Less ⌃' : 'More ⌄'}
            </button>
          )}
        </span>
      )}
    </div>
  );
};

export default MobileSectionHeader;
